import { downloadMedia } from 'src/utils/media/downloadMedia';
import { get } from 'utils/rest-clients';
import { MediaDownloadInfoModel } from '@utmost.co/enterprise-models/internal';

interface Model {
  resourceLocation?: Maybe<string> | undefined;
  resourceUid?: Maybe<string> | undefined;
}

export async function downloadMediaOrLink(model: Model, fileName?: string, onError?: (message: string) => void) {
  if (!model.resourceLocation && !model.resourceUid) {
    return;
  }
  if (model.resourceUid) {
    downloadMedia(model.resourceUid, fileName);
    return;
  }
  if (!model.resourceLocation) {
    return;
  }
  get<MediaDownloadInfoModel>(model.resourceLocation.replace('/api', ''))
    .then((response) => {
      if (response.data.downloadLink) {
        downloadMedia(response.data.downloadLink as string, fileName ?? response.data.filename);
      }
      return;
    })
    .catch((error) => {
      onError?.(error.message || error.error || error.toString() || 'Unknown error');
    });
}
